import { Dropdown, IconButton, Modal, ResponsiveMode } from "@fluentui/react";
import React, { useState } from "react";
import { FormTreeSelection } from "../cpm/FormTree";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { SourceTypeEnum } from "../../api/models/source-type-enum";
import { ScrollableFileTree } from "../document/FileTree";
import { FormTable } from "../interfaces/CoObject";
import { useDropDownModalStyles } from "./useDropDownModalStyles";

interface FileDropDownProps {
  updateFileExcelName?: (name: string) => void;
  onFileClick?: (selection: FormTreeSelection) => void;
  form: FormTable;
  objectSource: string;
  fileExcelName: string;
  isComponentInstance?: boolean;
  isLocked?: boolean;
}

export const FileDropDown = ({
  updateFileExcelName = () => {},
  onFileClick = () => {},
  form,
  objectSource,
  fileExcelName,
  isComponentInstance = false,
  isLocked = false,
}: FileDropDownProps) => {
  const { contentStyles, iconButtonStyles, cancelIcon, onRenderCaretDown } =
    useDropDownModalStyles(isComponentInstance);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  function handleFileClick(formSelection: FormTreeSelection) {
    setIsModalOpen(false);
    onFileClick(formSelection);
    updateFileExcelName(formSelection.formDesc);
  }

  function getFileName() {
    if (form) {
      if (objectSource !== SourceTypeEnum.EXCEL || fileExcelName === "") {
        return form.desc;
      } else {
        return fileExcelName;
      }
    }
    return formatMessage("cof.base.select");
  }

  return (
    <>
      <Dropdown
        id="file_dropdown"
        placeholder={getFileName()}
        label="File:"
        onRenderCaretDown={onRenderCaretDown}
        options={[]}
        onClick={() => isComponentInstance || setIsModalOpen(true)}
        responsiveMode={ResponsiveMode.large}
        disabled={objectSource !== SourceTypeEnum.EXCEL || isComponentInstance || isLocked}
        required
      />

      <Modal
        titleAriaId={"titleId"}
        isOpen={isModalOpen}
        onDismiss={() => setIsModalOpen(false)}
        isBlocking={false}
        containerClassName={contentStyles.container}
        styles={{
          main: {
            minHeight: "100%",
            minWidth: "100%",
          },
        }}
      >
        <div className={contentStyles.header}>
          <span id={"titleId"}>File</span>
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div className={contentStyles.body}>
          <ScrollableFileTree onFileClick={handleFileClick} oidPath={form ? form.oidPath : undefined} />
        </div>
      </Modal>
    </>
  );
};
